module.exports = __webpack_public_path__ + "static/media/img009.e9ec110c.jpg";